import { createElement, FC, ReactNode } from 'react';

export interface HeadingLayoutProps {
  children?: ReactNode;
  size?: string;
  color?: string;
  weight?: string;
  element?: string;
  className?: string;
}

const SIZES = {
  '': '',
  '4xs': 'text-sm/tight sm:text-base/tight md:text-lg/tight',
  '3xs': 'text-base/tight sm:text-lg/tight md:text-xl/tight',
  '2xs': 'text-lg/tight sm:text-xl/tight md:text-2xl/tight',
  xs: 'text-xl/tight sm:text-2xl/tight md:text-3xl/tight',
  sm: 'text-2xl/tight sm:text-3xl/tight md:text-4xl/tight',
  md: 'text-3xl/tight sm:text-4xl/tight md:text-5xl/tight',
  lg: 'text-4xl/tight sm:text-5xl/tight md:text-6xl/tight',
  xl: 'text-5xl/tight sm:text-6xl/tight md:text-7xl/tight',
  '2xl': 'text-4xl/tight sm:text-6xl/tight md:text-8xl/tight',
  '3xl': 'text-9xl/none',
  '4xl': 'text-10xl/none',
};

const COLOR = {
  white: 'text-white',
  beige: 'text-lift-beige',
  black: 'text-lift-black',
  gray: 'text-lift-grayLight',
  base: 'text-lift-grayDark',
  light: 'text-neutral-500 dark:text-neutral-500',
  dark: 'text-neutral-700 dark:text-neutral-300',
  darker: 'text-neutral-800 dark:text-neutral-200',
  primary: 'text-lift-red',
};

const WEIGHT = {
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  semi: 'font-semibold',
  bold: 'font-bold',
  black: 'font-black',
};

const HeadingLayout: FC<HeadingLayoutProps> = ({
  children,
  size = '',
  color = 'base',
  weight = 'bold',
  element = 'h2',
  className,
  ...props
}) => {
  const headingSizes = SIZES[size];
  const headingColor = COLOR[color];
  const headingWeight = WEIGHT[weight];

  return createElement(
    element,
    {
      className: `whitespace-break-spaces ${headingWeight} font-heading ${headingSizes} ${headingColor} ${className}`,
      ...props,
    },
    children
  );
};

export default HeadingLayout;
